import React from 'react';
import { useNavigate } from 'react-router-dom';
import VideoPlayer from '../media/VideoPlayer';
import { BOTTOM_VOD_URL, BOTTOM_VOD_THUMBNAIL } from '../../constants/background';
import { LandingCta } from '../../styles/LandingStyles';
import InnerContainer from './InnerContainer';
import Typography from '../common/typography/Typography';
import Button from '../common/button/Button';
import useVideoOptions from '../../hooks/useVideoOptions';
import useLanguagePack from '../../hooks/useLanguagePack';
import { checkIsMobile } from '../../utils';
import zIndex from '@mui/material/styles/zIndex';
const Section6 = () => {
  const navigate = useNavigate();
  const [option] = useVideoOptions(BOTTOM_VOD_THUMBNAIL, BOTTOM_VOD_URL);

  const languageKeyStrings = {
    contents: useLanguagePack('landing_cta_text_1'),
    buttonText: useLanguagePack('renew_landing_46'),

    contact: useLanguagePack('renew_landing_36'),
  };

  return (
    <LandingCta>
      <InnerContainer style={{ position: 'absolute', height: '100%', zIndex: 1,background:'linear-gradient(rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0) 100%)' }}>
        <Typography variant={'T3'}>{languageKeyStrings.contents}</Typography>
        <Button onClick={() => navigate('/signup')} color='primary' variant='contained' size='md'>
          {languageKeyStrings.buttonText}
        </Button>
      </InnerContainer>
      
      {!checkIsMobile() &&<VideoPlayer src={BOTTOM_VOD_URL} type={'video/mp4'} {...option} width={'100%'} />}
      {checkIsMobile() && <img src={BOTTOM_VOD_THUMBNAIL} width={'100%'}/>}
      <div style={{padding:'12px 0' ,zIndex:2 ,position:'relative'}}>
        <Typography variant={'C3'} style={{margin:'0px',cursor:'pointer'}} onClick={e=>{
          window.location.href= 'mailto:support@keycutstock.com'
        }}>{languageKeyStrings.contact}</Typography>
      </div>
    </LandingCta>
  );
};

export default Section6;
